import React from "react";
import { createRoot } from "react-dom/client";

import App from "./components/App";
import "./index.css";
import "@aws-amplify/ui-react/styles.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
